/// <reference path='_all.ts' />


// CHEAT SHEET: http://ivision.com/wp-content/uploads/AngularJS_v2.pdf

/**
 * Module for Trainings and Trainings Subscriptions.
 *
 * @type {angular.Module}
 */
module training {
  'use strict';

  var training = angular.module('training', [])
    .controller('trainingCtrl', TrainingCtrl)
  //  .directive('todoBlur', todoBlur)
  //  .directive('todoFocus', todoFocus)
    .service('trainingService', TrainingService);
}